// Validate list responses before replacing the last successfully loaded data.
// Staff and evaluation endpoints also support legacy items/bare-array responses.
export function assertListResponse(response) {
  const payload = response && response.data;
  if (!payload || payload.success === false ||
      !(Array.isArray(payload) || Array.isArray(payload.data) || Array.isArray(payload.items))) {
    throw new Error('List request did not return successful data');
  }
  return response;
}

const listLoads = new WeakMap();

// One request batch per component. Calls during a batch invalidate its result
// and share one trailing refresh; calls before it starts share the first batch.
export function queueLatestListLoad(vm, load) {
  let state = listLoads.get(vm);
  if (!state) {
    state = { revision: 0, promise: null, destroyed: false };
    listLoads.set(vm, state);
  }
  if (state.destroyed) return Promise.resolve();
  state.revision++;
  if (state.promise) return state.promise;

  vm.isLoading = true;
  state.promise = Promise.resolve().then(async () => {
    try {
      while (!state.destroyed) {
        const revision = state.revision;
        const isCurrent = () => !state.destroyed && revision === state.revision;
        await load(isCurrent);
        // No automatic retry: another batch requires an explicit refresh call.
        if (revision === state.revision) break;
      }
    } finally {
      // Release synchronously with the last batch so a new call cannot join a
      // settled drain and lose its refresh in a later promise-finally callback.
      state.promise = null;
      if (!state.destroyed) vm.isLoading = false;
    }
  });
  return state.promise;
}

export function disposeListLoad(vm) {
  const state = listLoads.get(vm) || {};
  state.destroyed = true;
  listLoads.set(vm, state);
}
